import { HeaderModule } from './header.module';

import { AppModule } from '../app.module';

import { Component, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { Router } from '@angular/router';




@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponentes {
  @ViewChild('interplantasButton', { static: true }) interplantasButton!: ElementRef;
  @ViewChild('interplantasMenu', { static: true }) interplantasMenu!: ElementRef;
  opcoes: string[] = ['Opção 1', 'Opção 2', 'Opção 3'];
  opcaoSelecionada!: string;
  selectedOption: string = "";
  alinharDireita = true;
  showDropdown = false;
  showDropdownTCM = false;
  showDropdownJSL = false;
  showDropdownLATINET = false;
  showDropdownTCMVW = false;
  showDropdownTCMSBCVW = false;
  showDropdownJSLVW = false;
  showDropdownJSLItaquaVW = false;
  showDropdownSESEVW = false;
  usuarioLogado!: UsuarioLogado;
  isCarrierTCMEnabled: boolean = true;
  isCarrierJSLEnabled: boolean = true;
  isCarrierJSLVWEnabled: boolean = true;
  isCarrierLOTSEnabled: boolean = true;
  isCarrierJSLARGEnabled: boolean = true;
  isCarrierEnabled: boolean = true;
  isConfigMenuOpen: boolean = false;
  isInterplantasMenuOpen = false;
  dropdownMenuStyle: any;
await: any;
  usuario!: boolean;



  constructor(
    private servicoAutenticacao: AutenticacaoService,
    private renderer: Renderer2,
    private router: Router
  ) {}

  public async logout(): Promise<void> {
    try {
      await this.servicoAutenticacao.logout();
      await this.getUserLogado();
      this.usuario = false;
    } catch (excecao: any) {
      const mensagemErro = excecao?.error?.erro || 'Erro ao realizar o logout!'
      alert(mensagemErro)
    }
  }
  

  public async login(): Promise<void> {
    this.router.navigate(['/login']);
  }


  toggleInterplantasMenu() {
    this.isInterplantasMenuOpen = !this.isInterplantasMenuOpen;
    if (this.isInterplantasMenuOpen) {
      this.positionDropdownMenu();
    }
  }

  openManual(): void {
    window.open('assets/Manual para solicitar Frete Extra.pptx', '_blank');
  }

  positionDropdownMenu() {
    const buttonElement = this.interplantasButton.nativeElement;
    const menuElement = this.interplantasMenu.nativeElement;
    this.dropdownMenuStyle = {
      position: 'absolute',
      top: `${buttonElement.offsetTop + buttonElement.offsetHeight}px`,
      left: `${buttonElement.offsetLeft}px`,
    };

  }

  toggleConfigMenu() {
    this.isConfigMenuOpen = !this.isConfigMenuOpen;
  }

  async ngOnInit() {
    this.changeCursorStyle(false);
    await this.getUserLogado();
  }

  changeCursorStyle(isMenuOpen: boolean) {
    const dropdownButton = document.getElementById('dropdownMenuButton');
    if (dropdownButton) {
      this.renderer.setStyle(dropdownButton, 'cursor', isMenuOpen ? 'default' : 'pointer');
    }
  }
  
  async getUserLogado(): Promise<UsuarioLogado> {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.servicoAutenticacao.obterUsuarioLogado()
    if (this.usuarioLogado.id != '') {
      this.usuario = true;
    }
    await this.enableFields();
    await this.enableFieldsTCM();
    await this.enableFieldsLOTS();
    await this.enableFieldsJSL();
    await this.enableFieldsJSLARG();
    await this.enableFieldsJSLVW();
    // //console.log(this.usuarioLogado)
    // //console.log(this.isCarrierEnabled)
    // //console.log(this.isCarrierTCMEnabled)
    // //console.log(this.isCarrierJSLARGEnabled)
    // //console.log(this.isCarrierLOTSEnabled)
    // //console.log(this.isCarrierJSLVWEnabled)
    return this.usuarioLogado 
  }
  
  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }
  
  enableFieldsTCM() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "TCM")) {
      this.isCarrierTCMEnabled = false;
    }
  }
  
  enableFieldsJSL() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL")) {
      this.isCarrierJSLEnabled = false;
    }
  }
  
  enableFieldsJSLARG() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-ARG")) {
      this.isCarrierJSLARGEnabled = false;
    }
  }
  
  enableFieldsLOTS() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "LOTS")) {
      this.isCarrierLOTSEnabled = false;
    }
  }
  
  enableFieldsJSLVW() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9' || (this.usuarioLogado.role == '3' && this.usuarioLogado.company == "JSL-VW")) {
      this.isCarrierJSLVWEnabled = false;
    }
  }
  
  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isCarrierEnabled = false;
    }
  }
  
  


}
